var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-text',{staticClass:"px-5",staticStyle:{"padding":".3rem 1rem"}},[_vm._v(" "+_vm._s(_vm._f("datetime")(_vm.current))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }